import React from "react";
import { Navigate as RouterNavigate, Route, Routes, useLocation } from "react-router-dom";
import PromoTrials from "../../features/promo trials";
import { HomeController } from "../home";
import { ResultsController } from "../scope";
import { ReviewTrialController } from "../review trials";
import {PtEnrollScreen} from "../review trials/trialdetails"
import { EnrollmentController, ThankYou } from "../enroll";
import { DataNotFound, Footer, Header, Loading } from "../../components";
import { Blogs } from "../blogs";
import { Domain, environment } from "../../constants";
import Preview from "../preview trials/preview";
import Kira from "../../components/kira";
import Mosaic from "../../components/mosaic";
import Vlu from "../../components/vlu";
import EMR from "../../components/Emr";
import EHR from "../../components/Ehr";
import Concierge from "../../components/Concierge";
import Nurse from "../../components/Nurse";
import Navigate from "../../components/Navigate";
import DeleteProspect from "../enroll/DeleteProspect";
//import Test from "../../components/Test";

const Navigation = () => {
  const location = useLocation();
  const isEmbedded = location.search && location.search.indexOf("embed=true") !== -1;

  return (
    <div>
      {isEmbedded ? <Header showHeader={false} /> : <Header />}
      <Routes>
        <Route path="/" element={<HomeController />} />
        <Route
          path="/signup"
          element={
            <RouterNavigate
              to={
                environment === "PROD"
                  ? "/enroll/STU01009"
                  : environment === "DEV"
                  ? "/enroll/STU0001002"
                  : "/enroll/STU01006"
              }
              replace
            />
          }
        />
        <Route
          path="/participate"
          element={
            <RouterNavigate
              to={
                environment === "PROD"
                  ? "/enroll/STU01009"
                  : environment === "DEV"
                  ? "/enroll/STU0001002"
                  : "/enroll/STU01006"
              }
              replace
            />
          }
        />
        <Route path="/results/" element={<ResultsController />} />
        <Route path="/KIRA" element={<Kira />} />
        <Route path="/kira" element={<Kira />} />
        <Route path="/mosaic" element={<Mosaic />} />
        <Route path="/MOSAIC" element={<Mosaic />} />
        <Route path="/vlu" element={<Vlu />} />
        <Route path="/VLU" element={<Vlu />} />
        <Route path="/concierge" element={<Concierge />} />
        <Route path="/nurse" element={<Nurse />} />
        {/* <Route path="/medical-records/:prospect/:city" element={<EMR />} />
        <Route path="/emr" element={<EHR />} /> */}
        {/* <Route path="/test" element={<Test />} /> */}
        <Route path="/study/:studyId" element={<ReviewTrialController />} />
        <Route path="/demo" element={<Navigate />} />
        <Route path="/thankyou/:pt" element={<ThankYou />} />
        <Route path="/deleteme" element={<DeleteProspect />} />
        <Route path="/upcoming-research/" element={<PtEnrollScreen />} />
        <Route path="/loading/" element={<Loading />} />
        <Route path="/enroll/:studyId" element={<EnrollmentController />} />
        {/* <Route path="/study/:nctid" element={<PromoTrials />} /> */}
        <Route path="/preview/:studyId" element={<Preview />} />
        {/* <Route path="/blog/:blogid" element={<Blogs />} />
        <Route path="/blog" element={<Blogs />} /> */}
        <Route path="*" element={<DataNotFound />} />
      </Routes>
      {isEmbedded ? <Footer showFooter={false} /> : <Footer />}
    </div>
  );
};

export default Navigation;
